import { MutationTree } from 'vuex';
import { State } from './commonState.store';
import { initialState } from '@/store/modules/synthetics/commonState/commonState.store';

const mutations: MutationTree<State> = {
  //TO DO : remove datatypes
  setSyntheticServices(state: State, data: any) {
    state.services = data;
    if (!state.currentService.key && data.length) {
      state.currentService = data[0];
    }
  },
  setCurrentSyntheticService(state: State, data: any) {
    state.currentService = data;
  },
  setCurrentSMPage(state: State, page: any) {
    state.currentSMPage = page;
  },
  setIsFormOpened(state: State, data: Boolean) {
    state.isFormOpened = data;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initialState });
  },
};

export default mutations;
